import { render, staticRenderFns } from "./UploadPage.vue?vue&type=template&id=1a9e7f28"
import script from "./UploadPage.vue?vue&type=script&lang=js"
export * from "./UploadPage.vue?vue&type=script&lang=js"
import style0 from "./UploadPage.vue?vue&type=style&index=0&id=1a9e7f28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports